import smerdova from "../../static/images/people/smerdova.jpg";
import drevojan from "../../static/images/people/drevojan.jpg";
import lososova from "../../static/images/people/lososova.jpg";
import divisek from "../../static/images/people/divisek.jpg";
import jaskova from "../../static/images/people/jaskova.jpg";
import rolecek from "../../static/images/people/rolecek.jpg";
import kalnikova from "../../static/images/people/kalnikova.jpg";
import kalusova from "../../static/images/people/kalusova.jpg";
import holubova from "../../static/images/people/holubova.jpg";
import tesitel from "../../static/images/people/tesitel.jpg";
import reznickova from "../../static/images/people/reznickova.jpg";
import novak from "../../static/images/people/novak.jpg";
import knollova from "../../static/images/people/knollova.jpg";
import vecera from "../../static/images/people/vecera.jpg";
import chytry from "../../static/images/people/chytry.jpg";
import galuskova from "../../static/images/people/galuskova.jpg";
import preislerova from "../../static/images/people/preislerova.jpg";
import marceno from "../../static/images/people/marceno.jpg";
import tichy from "../../static/images/people/tichy.jpg";
import landucci from "../../static/images/people/landucci.jpg";
import danihelka from "../../static/images/people/danihelka.jpg";
import taborska from "../../static/images/people/taborska.jpg";
import hajek from "../../static/images/people/hajek.jpg";
import zukal from "../../static/images/people/zukal.jpg";
import knotkova from "../../static/images/people/knotkova.jpg";
import stepankova from "../../static/images/people/stepankova.jpg";
import axmanova from "../../static/images/people/axmanova.jpg";
import kubesova from "../../static/images/people/kubesova.jpg";
import ceplova from "../../static/images/people/ceplova.jpg";
import cubino from "../../static/images/people/cubino.jpg";
import kolenyova from "../../static/images/people/kolenyova.jpg";
import midolo from "../../static/images/people/midolo.jpg";
import patsch from "../../static/images/people/patsch.jpg";
import erkelenz from "../../static/images/people/erkelenz.jpg";
import fahs from "../../static/images/people/fahs.jpg";
import chytrykr from "../../static/images/people/chytrykr.jpg";
import mones from "../../static/images/people/mones.jpg";
import ottaviani from "../../static/images/people/ottaviani.jpg";
import toumoulin from "../../static/images/people/toumoulin.jpg";
import iemelianova from "../../static/images/people/iemelianova.jpg";
import tesitelova from "../../static/images/people/tesitelova.jpg";
import klinkovska from "../../static/images/people/klinkovska.jpg";
import klimova from "../../static/images/people/klimova.jpg";
import szokala from "../../static/images/people/szokala.jpg";
import shyriaieva from "../../static/images/people/shyriaieva.jpg";
import sperandii from "../../static/images/people/sperandii.jpg";
import cuk from "../../static/images/people/cuk.jpg";
import knotek from "../../static/images/people/knotek.jpg";
import hubatka from "../../static/images/people/hubatka.jpg";
import franc from "../../static/images/people/franc.jpg";
import pustkova from "../../static/images/people/pustkova.jpg";
import sobotka from "../../static/images/people/sobotka.jpg";
import hanusova from "../../static/images/people/hanusova.jpg";
import chytra from "../../static/images/people/chytra.jpg";
import karnail from "../../static/images/people/karnail.jpg";
import kellermannova from "../../static/images/people/kellermannova.jpg";

export const peopleEn = {
  employees: [
    {
      id: `chytry`,
      name: `Milan Chytrý`,
      position: `Professor, Group Leader`,
      description: `Milan Chytrý got PhD in Botany at Masaryk University in 1995. He is interested in vegetation diversity, vegetation survey, methods of vegetation classification, macroecology, alien plant invasions and palaeoecology. He edited the Habitat Catalogue of the Czech Republic (2001, 2010) and the four-volume monograph Vegetation of the Czech Republic (2007–2013). In 2014–2018 he led the project PLADIAS, which synthesized information on flora and vegetation of the Czech Republic in an online database. He studied vegetation in different parts of Europe. In 2003–2015 he led projects of field research of ecosystems in different parts of Siberia, which resulted in characterizing some Siberian ecosystems as modern analogues of the Last Glacial ecosystems of Europe. Currently, he is coordinating the Centre of European Vegetation Syntheses at Masaryk University. He is a Secretary of the IAVS Working Group European Vegetation Survey, Custodian of the European Vegetation Archive (EVA) and Chief Editor of the IAVS journals (Journal of Vegetation Science and Applied Vegetation Science). He teaches Community Ecology and Macroecology, Vegetation and Habitats of the Czech Republic, Vegetation and Habitats of Europe and several field courses and seminars at Masaryk University.`,
      email: `chytry@sci.muni.cz`,
      phoneNumber: `549494595`,
      is: `https://www.muni.cz/en/people/871-milan-chytry`,
      orcid: `https://orcid.org/0000-0002-8122-3075`,
      publons: `https://publons.com/researcher/1609810/milan-chytry/`,
      scholar: `https://scholar.google.com/citations?user=scnnn1UAAAAJ&hl=cs&oi=ao`,
      researchgate: `https://www.researchgate.net/profile/Milan_Chytry`,
      personal: `https://www.sci.muni.cz/botany/chytry/index.htm`,
      img: chytry,
    },
    {
      id: `lososova`,
      name: `Zdeňka Lososová`,
      position: `Associate professor`,
      description: `Zdeňka Lososová has been employed at the Department of Botany and Zoology of Masaryk University since 2004. She is a guarantor of the study programmes of secondary school teacher training in biology. She leads botanical and geobotanical seminars. She also participates in leading the field course of Methods of Geobotany. Her current scientific interests focus on the diversity of vegetation. She is mainly interested in the vegetation of human-made habitats, especially in the effect of the urban environment on the occurrences of vascular plants in European cities and biological invasions. Recently she focusses on phylogenetic and functional diversity of plant communities. Based on these characteristics of plant communities, she tries to explain the role of environmental filtering and biotic interactions on the community assembly.`,
      email: `lososova@sci.muni.cz`,
      phoneNumber: `549498399`,
      is: `https://www.muni.cz/en/people/5767-zdenka-lososova`,
      orcid: `https://orcid.org/0000-0001-9152-7462`,
      publons: `https://publons.com/researcher/1641861/zdenka-lososova/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=E5qC_J8AAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Zdeka_Lososova`,
      img: lososova,
    },
    {
      id: `rolecek`,
      name: `Jan Roleček`,
      position: `Associate professor`,
      description: `Jan Roleček is interested in ecology and diversity of vegetation, especially forest-steppe habitats such as thermophilous oak forests and steppe meadows. Besides describing this diversity, he also tries to understand its causes, which has led him to study forest-steppes in remote areas of Eurasia and also to explore their history on different time scales. As a graduate in the field of Environmental Conservation (Palacký University in Olomouc), he is also concerned with the protection of endangered species and habitats, and he devotes part of his work to them. After completing his PhD in Botany at Masaryk University (2001–2007), he stayed faithful to the Department of Botany and Zoology and at the same time he works at the Institute of Botany of the Czech Academy of Sciences. He leads lectures in Forest Ecology, Protected Areas of the Czech Republic, Quaternary Environments (with M. Horsák) and Special Field Practice in Botany and Zoology (with Biotým).`,
      email: `rolecek@mail.muni.cz`,
      phoneNumber: `549498489`,
      is: `https://www.muni.cz/en/people/42706-jan-rolecek`,
      orcid: `https://orcid.org/0000-0002-0023-1111`,
      publons: `https://publons.com/researcher/2518519/jan-rolecek/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=E0X-9JAAAAAJ`,
      researchgate: `https://www.researchgate.net/scientific-contributions/78391540_Jan_Rolecek`,
      img: rolecek,
    },
    {
      id: `tesitel`,
      name: `Jakub Těšitel`,
      position: `Associate professor`,
      description: `Jakub Těšitel started his job at the Department of Botany and Zoology, Masaryk University in 2017. He teaches the course Introduction to Biostatistics in English and contributes to various seminars and field courses. His main research interest concerns the ecology of parasitic plants. He also deals with a series of other topics related to grassland biodiversity like plant functional traits and their importance for ecology or temporal variability of plant communities. Apart from fundamental research, he is keen on using his experience in applied ecology. He tries to use hemiparasitic plants to suppress plant invasions and enhance the biodiversity of synanthropic habitats. Jakub did his master and PhD studies at the Faculty of Science, University of South Bohemia in České Budějovice where he was subsequently employed as a researcher and assistant professor. His master and PhD theses focused on taxonomy, ecology and physiology of hemiparasitic Orobanchaceae. `,
      email: `tesitel@sci.muni.cz`,
      phoneNumber: `549496974`,
      is: `https://www.muni.cz/en/people/116967-jakub-tesitel`,
      orcid: `https://orcid.org/0000-0003-3793-3704`,
      publons: `https://publons.com/researcher/2869771/jakub-tesitel/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=ipOViTQAAAAJ`,
      researchgate: `https://www.researchgate.net/scientific-contributions/46226749_Jakub_Tesitel`,
      img: tesitel,
    },
    {
      id: `tichy`,
      name: `Lubomír Tichý`,
      position: `Associate professor`,
      description: `Lubomír Tichý finished his doctoral study in Botany at Masaryk University in 1999 with the thesis "The Influence of Habitat Conditions on Vegetation Diversity". He focuses on methods and theoretical aspects of vegetation data collection and classification of vegetation types. Since 1988 he is interested in a nature monitoring, protection and management of nature reserves. He is an author of software tools for data collection and vegetation analysis and classification, e.g. JUICE, GLAMA and Probabilistic Vegetation Key. He teaches Plant Population Ecology, Processing Basic Botanical Data, Field Course in Geobotany and some other courses including Botanical seminar – Vegetation of Central Europe at the Faculty of Social Studies. He is a guarantor of the master programme Nature Conservation.`,
      email: `tichy@sci.muni.cz`,
      phoneNumber: `549497673`,
      is: `https://www.muni.cz/en/people/6669-lubomir-tichy`,
      orcid: `https://orcid.org/0000-0003-3793-3704`,
      publons: `https://publons.com/researcher/2869771/jakub-tesitel/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=ipOViTQAAAAJ`,
      researchgate: `https://www.researchgate.net/scientific-contributions/46226749_Jakub_Tesitel`,
      img: tichy,
    },
    {
      id: `axmanova`,
      name: `Irena Axmanová`,
      position: `Assistant professor`,
      description: `Irena Axmanová studied Systematic Botany and Ecology at the Department of Botany and Zoology of Masaryk University. She continued with postgraduate studies at the same department, and in 2012 she defended her PhD thesis "The effect of productivity and other environmental factors on the forest herb-layer diversity". She was involved in a project looking for modern analogues of vegetation in the Late Pleistocene, asking which habitats were preferred by mammoths and other mega-herbivores in late glacial. Currently, she cooperates on projects based on the extensive phytosociological database European Vegetation Archive (EVA) to study vegetation patterns at the European scale. She is mainly interested in vegetation ecology, alien species, and functional and phylogenetic diversity of plant communities.`,
      email: `axmanova@sci.muni.cz`,
      phoneNumber: `549498395`,
      is: `https://www.muni.cz/en/people/78388-irena-axmanova`,
      orcid: `https://orcid.org/0000-0001-9440-7976`,
      publons: `https://publons.com/researcher/3126272/irena-axmanova/`,
      researchgate: `https://www.researchgate.net/profile/Irena_Axmanova`,
      img: axmanova,
    },
    {
      id: `danihelka`,
      name: `Jiří Danihelka`,
      position: `Assistant professor`,
      description: `Jiří Danihelka obtained his PhD in Botany at the Faculty of Science of Masaryk University in 2000, defending the thesis Achillea millefolium agg. in the Czech Republic. Since then he has been working at the Department of Botany and Zoology, since 2004 as the curator of Masaryk University Herbarium (international acronym BRNU). Since 2004 he has also been working at the Institute of Botany of the Czech Academy of Sciences in Průhonice. At present, he focuses at curating the University’s herbarium, taxonomic and plant geographic databases, identification handbooks and botanical monographs (Flora of the Czech Republic and Flora of Slovakia), and also on the taxonomy and distribution of alien species and some difficult genera of the Central European flora, including Achillea, Cerastium, Epilobium, Stipa and Viola. He teaches Basic Methods of Field Botany, Scientific Work in Botany and Zoology, Processing Basic Botanical Data, Angiosperm Identification Course and Field Course of Systematic Botany.`,
      email: `danihel@sci.muni.cz`,
      phoneNumber: `549 49 3473`,
      is: `https://www.muni.cz/en/people/5926-jiri-danihelka`,
      orcid: `https://orcid.org/0000-0002-2640-7867`,
      publons: `https://publons.com/researcher/2523760/jiri-danihelka/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=10pWhfkAAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Jii_Danihelka`,
      img: danihelka,
    },
    {
      id: `divisek`,
      name: `Jan Divíšek`,
      position: `Assistant professor`,
      description: `Jan Divíšek studied Upper Secondary School Teacher Training in Biology and Geography at Masaryk University. He then continued with the PhD study of Physical Geography at the same institution, and in 2015, he defended his PhD thesis dealing with biogeography and beta diversity of species assemblages of various taxonomical groups in the Czech Republic. Currently, he works as an assistant professor at the Department of Botany and Zoology, and also at the Department of Geography of Masaryk University. He is mainly interested in biodiversity patterns, invasion ecology, and spatial modeling. Questions connected with his research include, for example: What is the effect of past landscape changes on current regional differences in plant species richness? What traits determine the success of alien species? or How does the distribution species or whole communities change in response to environmental changes?`,
      email: `divisekjan@mail.muni.cz`,
      phoneNumber: `549498494`,
      is: `https://www.muni.cz/en/people/106310-jan-divisek`,
      orcid: `https://orcid.org/0000-0002-5127-5130`,
      publons: `https://publons.com/researcher/2524551/jan-divisek/`,
      researchgate: `https://www.researchgate.net/profile/Jan_Divisek`,
      img: divisek,
    },
    {
      id: `novak`,
      name: `Pavel Novák`,
      position: `Assistant professor`,
      description: `Pavel Novák studied Botany (focused on plant ecology) at Masaryk University, Brno. He graduated with a master degree in 2013. His master thesis dealt with the variability of forest vegetation in the Krumlovský les Forest and its surroundings (SW Moravia). His PhD study (2014–2020) was aimed at the variability and syntaxonomy of oak-hornbeam forests (order Carpinetalia) on the European scale. Besides Central Europe, he studies forest vegetation of the Caucasus and the Euxinian Region.`,
      email: `269109@mail.muni.cz`,
      phoneNumber: `549498485`,
      is: `https://www.muni.cz/en/people/269109-pavel-novak`,
      researchgate: `https://www.researchgate.net/profile/Pavel_Novak21`,
      img: novak,
    },
    {
      id: `chytra`,
      name: `Helena Chytrá`,
      position: `Researcher  `,
      description: `I focus on the conservation management of dry grasslands (including innovative approaches such as burning and fallowing), as well as their establishment and management on arable land. I also work on options for supporting biodiversity in agricultural landscapes, particularly in vineyards. In my free time, I engage in community-based landscape management.`,
      email: `chytra@sci.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/103586-helena-chytra`,
      img: chytra,
    },
    {
      id: `chytrykr`,
      name: `Kryštof Chytrý`,
      position: `Researcher`,
      description: `Kryštof Chytrý is interested in the biogeography of Central European flora and vegetation. While being interested in biogeographical patterns and gradients, he is most intrigued by what ostensibly undermines them. Through these interests, he ended up dealing with research questions such as incidence of steppe patches in mostly forested Central European landscape (Master thesis), presence of microclimatic refugia in high mountains (ongoing PhD thesis at the University of Vienna) and seasonal and interannual dynamics of dry grasslands.`,
      email: `krystof.chytry@gmail.com`,
      phoneNumber: `+420731877397`,
      is: `https://www.muni.cz/en/people/237932-krystof-chytry`,
      orcid: `https://orcid.org/0000-0003-4113-6564`,
      researchgate: `https://www.researchgate.net/profile/Krystof-Chytry`,
      publons: `https://publons.com/researcher/4044399/krystof-chytry/`,
      personal: `https://twitter.com/Kryshpean21`,
      img: chytrykr,
    },
    {
      id: `klinkovska`,
      name: `Klára Friesová (Klinkovská)`,
      position: `Researcher`,
      description: `Klára Friesová studied the bachelor's degree programme Ecological and Evolutionary Biology and then the master's study programme Botany with a focus on plant ecology at the Faculty of Science, Masaryk University. In her bachelor's thesis, she focused on vegetation characteristics of geographically distinct floral elements of the Slavkov region. In her master’s thesis, she studied the tall-herb steppe vegetation of South Moravia. The main goal of her PhD study was to synthesize the main trends in the changes of species diversity in Czech non-forest vegetation over the recent decades based on the vegetation-plot data. She is also interested in recognising the underlying factors of vegetation change to contribute to effective nature conservation.`,
      email: `474368@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/474368-klara-klinkovska`,
      researchgate: `https://www.researchgate.net/profile/Klara_Klinkovska`,
      orcid: `https://orcid.org/0000-0002-1644-2140`,
      img: klinkovska,
    },
    {
      id: `hajek`,
      name: `Ondřej Hájek`,
      position: `Researcher`,
      description: `Ondřej Hájek graduated in Cartography and Geoinformatics at the Faculty of Science, Masaryk University. Now he works for most of the working groups of the Department of Botany and Zoology as a GIS expert. At the same time, he teaches the course Geographical Information Systems in Botany and Zoology.`,
      email: `ohajek@sci.muni.cz`,
      phoneNumber: `549494033`,
      is: `https://www.muni.cz/en/people/16845-ondrej-hajek`,
      researchgate: `https://www.researchgate.net/profile/Ondej_Hajek`,
      img: hajek,
    },
    {
      id: `hanusova`,
      name: `Valérie Hanušová`,
      position: `Researcher  `,
      description: `Valérie Hanušová completed her Master’s degree in Nature Conservation with a specialization in Botany at the Faculty of Science, Masaryk University. In her Master’s thesis, she focused on practical nature conservation throught the restoration of grassland biodiversity using green hay transfer following the suppression of invasive species dominance by hemiparasitic plants. She is currently involved in the cross-border Interreg PannFlora project, which focuses on the restoration of biodiversity-rich grasslands and the production of regional seed mixtures from native Pannonian plant species for use in landscape restoration and in urban green spaces.`,
      email: `541000@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://is.muni.cz/osoba/541000?lang=en`,
      img: hanusova,
    },
    {
      id: `holubova`,
      name: `Dana Holubová`,
      position: `Researcher`,
      description: `Dana Holubová studied Systematic Botany and Ecology in the Department of Botany and Zoology, Faculty of Science, Masaryk University. She continued with PhD studies at the same Department and in 2016 defended a PhD thesis focused on the diversity of vegetation on the landscape scale. In 2011 she created a web application Botanical Photogallery, which she still manages. Currently, she is a researcher at the Department of Botany and Zoology, where she is curating botanical photographic databases including those for the web application PLADIAS.`,
      email: `danmich@mail.muni.cz`,
      phoneNumber: `549496974`,
      is: `https://www.muni.cz/en/people/113226-dana-holubova`,
      researchgate: `https://www.researchgate.net/scientific-contributions/2149640262_Dana_Holubova`,
      img: holubova,
    },

    {
      id: `iemelianova`,
      name: `Svitlana Iemelianova`,
      position: `Researcher`,
      description: `Svitlana Iemelianova is from Ukraine. She concluded her PhD thesis in 2015 at the M.G. Kholodny Institute of Botany of the National Academy of Science of Ukraine. She focuses on vegetation classification, plant invasions in different habitat types, and nature conservation.`,
      email: `yemelianova.sv@gmail.com`,
      is: `https://www.muni.cz/en/people/242944-svitlana-iemelianova`,
      orcid: `https://orcid.org/0000-0001-5885-3186`,
      researchgate: `https://www.researchgate.net/profile/Svitlana-Iemelianova`,
      publons: `https://publons.com/researcher/3340751/svitlana-iemelianova/`,
      img: iemelianova,
    },

    {
      id: `kalusova`,
      name: `Veronika Kalusová`,
      position: `Researcher`,
      description: `Veronika Kalusová studied Systematic Biology and Ecology at the Faculty of Science, Masaryk University (2003–2009). In the Bachelor and Master theses, she focused on habitat preferences of alien plant species in river alluvia of south-eastern Moravia, Czech Republic. She continued with PhD studies in Botany at the same faculty. In 2015 she defended her PhD thesis dealing with the intercontinental comparison of habitats as sources of alien plants and alien plant exchange between Europe, North America and other regions. Since 2009 she works as a researcher at the Department of Botany and Zoology. She is mainly interested in alien plant invasions including patterns and mechanisms of invasions in various vegetation types of Europe with a special emphasis on the vegetation and flora of human settlements.`,
      email: `kalveron@tiscali.cz`,
      phoneNumber: `549494992`,
      is: `https://www.muni.cz/en/people/106856-veronika-kalusova`,
      orcid: `https://orcid.org/0000-0002-4270-321X`,
      researchgate: `https://www.researchgate.net/profile/Veronika_Kalusova`,
      img: kalusova,
    },
    {
      id: `knollova`,
      name: `Ilona Knollová`,
      position: `Researcher`,
      description: `Ilona Knollová studied Systematic Biology and Ecology in the Department of Botany and Zoology, Faculty of Science, Masaryk University. She continued with PhD studies at the same Department and in 2006 defended her PhD thesis "Local and large-scale data sets and their use for vegetation classification". Currently, she works as the manager of the Czech Vegetation Database and European Vegetation Archive (EVA).`,
      email: `ikuzel@sci.muni.cz`,
      phoneNumber: `549498488`,
      is: `https://www.muni.cz/en/people/10355-ilona-knollova`,
      orcid: `https://orcid.org/0000-0003-4074-789X`,
      researchgate: `https://www.researchgate.net/profile/Ilona_Knollova`,
      img: knollova,
    },
    {
      id: `knotkova`,
      name: `Kateřina Knotková`,
      position: `Researcher`,
      description: `Kateřina Knotková studied Landscape Architecture at Faculty of Horticulture, Mendel University in Brno. Her interests were focused mainly on plants. Her bachelor thesis was aimed at creation of a botanical garden in the National park Podyjí made of natural plant assemblages that occur in this national park. In her diploma thesis, she tested plant species that could be cultivated in cities by direct sowing and also addressed rain gardens, a much-discussed topic today. Now she is continuing in her doctoral studies at the Department of Botany and Zoology, Faculty of Science, Masaryk University. The topic of her PhD thesis is hemiparasitic plants and their influence on biodiversity and ecosystem services. In her works, she combines knowledge and approaches of horticulture and basic botanical research.`,
      email: `501016@mail.muni.cz`,
      phoneNumber: `549496974`,
      is: `https://www.muni.cz/en/people/501016-katerina-knotkova`,
      orcid: `https://orcid.org/0000-0001-6668-8977`,
      researchgate: `https://www.researchgate.net/profile/Katerina-Knotkova-3`,
      img: knotkova,
    },
	    {
      id: `kolenyova`,
      name: `Monika Kolényová`,
      position: `Researcher`,
      description: `Monika Kolényová studied Botany (Mycology) at Masaryk University, Brno. She graduated with a master degree in 2020 and started her ongoing PhD study, which is aimed at the ecology, succesion and microhabitats of lignicolous fungi on logs in natural forests in Europe.`,
      email: `424056@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://www.sci.muni.cz/en/about-us/faculty-staff/424056`,
      researchgate: `https://www.researchgate.net/profile/Monika_Kolenyova`,
      img: kolenyova,
    },
    {
      id: `kubesova`,
      name: `Svatava Kubešová`,
      position: `Researcher`,
      description: `Svatava Kubešová completed her studies at Masaryk University with a rigorous degree. At the Department of Botany and Zoology, she participates in teaching bryology with two determination courses. Her main job is to manage collections of bryophytes as a curator in the Moravian Museum.`,
      email: `skubesova@mzm.cz`,
      phoneNumber: `545217322`,
      is: `https://www.muni.cz/en/people/18604-svatava-kubesova`,
      orcid: `https://orcid.org/0000-0002-7895-6710`,
      publons: `https://publons.com/researcher/2339456/svatava-kubesova/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=g1_cBe0AAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Svatava_Kubesova`,
      img: kubesova,
    },
    {
      id: `landucci`,
      name: `Flavia Landucci`,
      position: `Researcher`,
      description: `Flavia Landucci studied Natural Science at the University of Perugia, Italy, where she graduated and obtained her PhD degree in botany and vegetation science. During her bachelor and master studies, she focused on the distribution, ecology and phytochemistry of the exotic species Senecio inaequidens in Italy. During that time, she realized that her favourite part of botany is the study of plant and community ecology. During the PhD she started to develop her interest in aquatic and wetland vegetation. She first came to Brno as a PhD student for an Erasmus stay in 2010. At Masaryk University, she found a very positive and stimulating environment with cooperative people that encouraged her to continue her research after the PhD. She got the PhD degree in 2011 with a thesis about the classification of aquatic and wetland vegetation of Central Italy. In 2013 she successfully applied for a SoMoPro project (co-funded by the Marie Curie actions and the South Moravian Region) and since that time she has worked in the Vegetation Science Group at the Department of Botany and Zoology of Masaryk University. Her research is currently mainly focused on the classification of aquatic and wetland vegetation of Europe.`,
      email: `386683@mail.muni.cz`,
      phoneNumber: `549498479`,
      is: `https://www.muni.cz/en/people/386683-flavia-landucci`,
      orcid: `https://orcid.org/0000-0002-6848-0384`,
      publons: `https://publons.com/researcher/1282963/flavia-landucci/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=UJn3DmQAAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Flavia_Landucci`,
      img: landucci,
    },
    {
      id: `preislerova`,
      name: `Zdenka Preislerová`,
      position: `Researcher`,
      description: `Zdenka Preislerová studied Systematic Botany and Geobotany at Masaryk University, and her master thesis was focused on the weed vegetation in the White Carpathians (1999). Results were published as a monograph in 2001. In her PhD project, completed in 2006, wshe dealt with the influence of various plot size on the analysis and classification of vegetation, using examples of forest and grassland vegetation. She is interested in the causes of species richness patterns in dry and semi-dry grasslands in the White Carpathians and other regions. Currently, she is involved in the processing of data on European vegetation alliances.`,
      email: `zpreislerova@gmail.com`,
      phoneNumber: `549498477`,
      is: `https://www.muni.cz/en/people/10230-zdenka-preislerova`,
      orcid: `https://orcid.org/0000-0002-6848-0384`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=UJn3DmQAAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Flavia_Landucci`,
      img: preislerova,
    },
    {
      id: `reznickova`,
      name: `Marcela Řezníčková`,
      position: `Researcher`,
      description: `Marcela Řezníčková graduated in Systematic Biology and Ecology from the Faculty of Science, Masaryk University (1995–2000). She completed this study by defending her diploma thesis "Forest vegetation of the Chřiby Mountains". Since 2002 she continued her doctoral studies at the same university and in 2007 she defended her PhD thesis "Variability of Molinion meadows in the Czech and Slovak Republics". Currently she is a specialist at the Department of Botany and Zoology (MU) and is mainly involved in the administration of the PLADIAS database.`,
      email: `mar.reznickova@seznam.cz`,
      phoneNumber: `549498488`,
      is: `https://www.muni.cz/en/people/19437-marcela-reznickova`,
      researchgate: `https://www.researchgate.net/profile/Marcela_Reznickova`,
      img: reznickova,
    },
    {
      id: `smerdova`,
      name: `Eva Šmerdová (Hettenbergerová)`,
      position: `Researcher (maternity leave)`,
      description: `Eva Šmerdová studied Plant Systematics and Ecology at the University of Ostrava. She continued in the master study of Botany at Masaryk University, and was graduated in 2006. Her master thesis dealt with the effect of contact plant communities on the species composition of spring fens. Her PhD thesis dealt with species richness of plants and molluscs along the moisture gradient. Currently, she works on public relation of botany and zoology, focusing mainly on the students of high and secondary school. She cooperates in projects dealing with (1) the influence of the artificial snow on vegetation and (2) the refugia of endangered fen plant species. She also works on the database of plant macrofossils of the Czech and Slovak Republic. She likes to travel with co-workers to sample field data for research projects.`,
      email: `smerdova@sci.muni.cz`,
      phoneNumber: `549498487`,
      is: `https://www.muni.cz/en/people/75764-eva-smerdova`,
      orcid: `https://orcid.org/0000-0003-4589-6317`,
      researchgate: `https://www.researchgate.net/profile/Eva-Smerdova-2`,
      publons: `https://publons.com/researcher/4960709/eva-smerdova/`,
      img: smerdova,
    },
        {
      id: `tesitelova`,
      name: `Tamara Těšitelová`,
      position: `Researcher`,
      description: `Tamara Těšitelová studied botany at the Faculty of Science at the University of South Bohemia in Budweis. She finished her Ph.D. training in 2014 by defencing a thesis called „Ecological and evolutionary consequences of orchid dependence on mycorrhizal fungi“. For studies of the orchid-fungi relationship, she used numerous approaches, such as field experiments with orchid seed sowing, isolation of mycorrhizal fungi in culture, molecular barcoding, including high-throughput sequencing of root and soil samples, phylogenetic analyses, as well as electron microscopy and stable isotope analyses. Tamara joined the Department of Botany and Zoology at Masaryk University in 2021. In her current research, she focuses on the ability of hemiparasitic plants to suppress invasive plants, the ecology of mycoheterotrophic plants based on vegetation databases, and anthropogenic effects on orchid mycorrhizal fungi in soil. `,
      email: `tamara.malinova@centrum.cz`,
      is: `https://www.muni.cz/en/people/246803-tamara-tesitelova`,
      orcid: `https://orcid.org/0000-0001-6901-6359`,
      img: tesitelova,
    },
    {
      id: `vecera`,
      name: `Martin Večeřa`,
      position: `Researcher`,
      description: `Martin Večeřa graduated in Geography, with a specialization in Landscape Ecology and Biogeography, at the Faculty of Science, Masaryk University. In his master thesis, he dealt with the dispersal of forest plants along the strips of woody vegetation (potential biotic corridors) in an agricultural landscape. The topic of his dissertation thesis was species diversity of forest and grassland plant communities in Europe and its various ecological and biogeographical aspects.`,
      email: `martinvec@seznam.cz`,
      phoneNumber: `549498494`,
      is: `https://www.muni.cz/en/people/357693-martin-vecera`,
      orcid: `https://orcid.org/0000-0001-8507-791X`,
      researchgate: `https://www.researchgate.net/profile/Martin_Vecera`,
      img: vecera,
    },
    {
      id: `drevojan`,
      name: `Pavel Dřevojan`,
      position: `Researcher`,
      description: `Pavel Dřevojan studied Botany at the Faculty of Science of Masaryk University. In his bachelor thesis he studied dry grassland flora and vegetation along a railway in the White Carpathians. In his master thesis he studied the diversity of arable field vegetation in the Znojmo District of south-western Moravia. His main interests include the study of flora and vegetation of southern Moravia. He participates as a research assistant in different projects of the Vegetation Science Group.`,
      email: `269768@mail.muni.cz`,
      phoneNumber: `549498486`,
      is: `https://www.muni.cz/en/people/269768-pavel-drevojan`,
      publons: `https://publons.com/researcher/1805476/pavel-drevojan/`,
      researchgate: `https://www.researchgate.net/profile/Pavel_Devojan`,
      img: drevojan,
    },
    {
      id: `galuskova`,
      name: `Hana Hrdličková (Galušková)`,
      position: `Researcher (maternity leave)`,
      description: `Hana Hrdličková graduated in Upper Secondary School Teacher Training in Biology from the Faculty of Science, Masaryk University in 2014. Her master thesis focused on floristic diversity around Uherský Ostroh in southern Moravia. She works as a technician in the Herbarium of Masaryk University.`,
      email: `357936@mail.muni.cz`,
      phoneNumber: `549494813`,
      img: galuskova,
    },
  ],

  phdStudents: [
    {
      id: `erkelenz`,
      name: `Joshua André Erkelenz`,
      position: `PhD student, Researcher`,
      description: `Joshua Erkelenz studied forestry and forest ecology at the Georg-August University in Göttingen, Germany. Prior to and during his tropical and international forestry Master Program, he conducted several research projects abroad and graduated with a thesis on patterns of functional diversity on the oceanic island of Tenerife. Continuing in this exciting field of ecological research, he now studies functional and phylogenetic diversity in forest communities along elevational gradients in European mountain ranges at the Department of botany and zoology as part of his Ph.D. He devotes some of his time to the cultivation of tropical and subtropical crops.`,
      email: `erkelenz@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/528856-joshua-andre-erkelenz`,
      orcid: `https://orcid.org/0009-0005-7339-6741`,
      researchgate: `https://www.researchgate.net/profile/Joshua-Erkelenz`,
      img: erkelenz,
    },
    {
      id: `fahs`,
      name: `Nina Fahs`,
      position: `PhD student, Researcher`,
      description: `Nina Fahs graduated in International Technical and Applied Biology from the
City University of Applied Sciences in Bremen, Germany. After finishing her
Master’s project, for which Nina was working on the description and
classification of mesic alluvial grasslands in northern Germany, she joined the
Vegetation Science Group as a Ph.D. student in 2020. For her doctoral studies
she now investigates the multi-faceted interaction between hemiparasitic plants
and legumes, with a focus on grassland communities. Nina’s broad interests are
the field of Geobotany, the use of extensive vegetation-plot databases for both
basic and applied research and Nature Conservation, especially the conservation
and restoration of semi-natural species-rich grasslands.`,
      email: `nina@sci.muni.cz`,
      phoneNumber: `549498395`,
      is: `https://www.muni.cz/en/people/528656-nina-fahs`,
      researchgate: `https://www.researchgate.net/profile/Nina-Fahs`,
      orcid: `https://orcid.org/0000-0003-4078-7672`,
      img: fahs,
    },
    {
      id: `franc`,
      name: `Martin Franc`,
      position: `PhD student, Researcher  `,
      description: `Martin Franc graduated in Ecology and Environmental Protection at Palacký University in Olomouc, where he focused on the endangered flora of meadows in the central part of the White Carpathians and subsequently on the ecology of semi-natural grasslands in Latvia and their relationship to the soil environment. During his PhD studies, he is interested in the ecology of specialised functional groups of plants such as parasites, mycoheterotrophs, carnivorous plants and nitrogen fixers, especially their relation to soil environmental conditions.`,
      email: `437048@mail.muni.cz`,
      is: `https://www.muni.cz/en/people/437048-martin-franc`,
      researchgate: `https://www.researchgate.net/profile/Martin_Franc2`,
      img: franc,
    },
    {
      id: `hubatka`,
      name: `Petr Hubatka`,
      position: `PhD student, Researcher  `,
      description: `Petr Hubatka studied botany at the Faculty of Science, Masaryk University, where he defended in 2023 his master thesis Flora and vegetation on wet arable land in southern Moravia. His PhD study aims at the diversity of deciduous oak forests in southeastern Europe. He is interested in European flora, vegetation, and factors that determine their diversity.`,
      email: `460527@mail.muni.cz`,
      is: `https://www.muni.cz/en/people/460527-petr-hubatka`,
      researchgate: `https://www.researchgate.net/profile/Petr-Hubatka`,
      orcid: `https://orcid.org/0000-0001-8178-5230`,
      img: hubatka,
    },
    {
      id: `jaskova`,
      name: `Anni Kanerva Jašková`,
      position: `PhD student, Researcher (maternity leave) `,
      description: `Anni Jašková is a PhD student specializing in boreal vegetation. The main goal of her thesis is to create a unified European-scale vegetation classification of the boreal forests, but her interests also lay in theoretical ecology, especially plant strategies and plant-herbivore-interactions. Anni is originally from Finland, where she studied in the University of Turku, majoring in Ecology. Before undertaking the boreal vegetation, she started with the arctic ecosystems, investigating the interactions between lemmings and lichens in Fennoscandian tundra.`,
      email: `annipyy@mail.muni.cz`,
      phoneNumber: `549498395`,
      is: `https://www.muni.cz/en/people/452344-anni-kanerva-pyykoenen`,
      researchgate: `https://www.researchgate.net/profile/Anni_Pyykoenen`,
      orcid: `https://orcid.org/0000-0002-3510-1093`,
      img: jaskova,
    },
	{
      id: `karnail`,
      name: `Anisha Ajay Karnail`,
      position: `PhD student, Researcher  `,
      description: `Anisha Karnail studied biology at Indian Institute of Science Education and Research, Pune in India. She completed her Master’s project in 2022, analyzing tree growth patterns against environmental gradients in different forest types of southern India. After brief stints in science communication and urban ecology research, she joined the Vegetation Science Group as a Ph.D. student in 2026. Anisha's thesis focuses on the ecophysiological interactions of parasitic mistletoe and its host tree species in central Europe. Her broad research interests are in biodiversity conservation, restoration, and urban sustainability.`,
      email: `590504@muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/590504-anisha-ajay-karnail`,
      researchgate: ``,
	  orcid: ``, 
      img: karnail,
    },	
	{
      id: `kellermannova`,
      name: `Julia Kellermannová`,
      position: `PhD student, Researcher  `,
      description: `Julia Kellermannová completed a Bachelor’s degree in Biology and Ecology, followed by a Master’s degree in Botany at Palacký University in Olomouc. In both her Bachelor’s and Master’s theses, she focused on the functional variability of forest herbaceous species across a local gradient of environmental conditions. As part of her doctoral studies, she will investigate vegetation, floristic and functional changes in European wetlands. The aim of this research will be not only to identify trends and factors driving these changes, but also to create a European database of repeated surveys of wetland vegetation and to optimise management strategies and the revitalisation of these habitat types.`,
      email: `499970@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/499970`,
      researchgate: ``,
	  orcid: ``, 
      img: kellermannova,
    },
    {
      id: `klimova`,
      name: `Barbora Klímová`,
      position: `PhD student, Researcher`,
      description: `Barbora Klímová studied physical geography at the Faculty of Science of Masaryk
University, where she specialized in landscape ecology and biogeography. In her master
thesis, she dealt with the influence of soil pH maps on the accuracy of plant distribution
models. She is currently continuing her studies at the Department of Botany and Zoology,
where, as a part of her PhD studies, she focuses on factors that affect the accuracy of
geographical models of plant distribution and species richness.`,
      email: `470403@muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/470403-barbora-klimova`,
      researchgate: `https://www.researchgate.net/profile/Barbora_Klimova`,
      img: klimova,
    },

    {
      id: `pustkova`,
      name: `Štěpánka Pustková`,
      position: `Doktorand, výzkumník`,
      description: `Štěpánka Pustková vystudovala na Masarykově uiverzitě bakalářský program Ekologická a evoluční biologie a magisterský program Botanika se zaměřením na vegetační ekologii. V bakalářské práci se zabývala dlouhodobými změnami lesní vegetace v Beskydském podhůří. Ve své diplomové práci zkoumala flóru a vegetaci revitalizovaných mokřadů na jižní Moravě. V dizertaci se opět vrátila k tématu změn lesní vegetace, tentokrát však v jihovýchodní Evropě.`,
      email: `499933@muni.cz`,
      is: `https://www.sci.muni.cz/en/about-us/faculty-staff/499933-stepanka-pustkova`,
      orcid: `https://orcid.org/0000-0002-9384-4872`,
      img: pustkova,
    },
	{
      id: `sobotka`,
      name: `Vojtěch Sobotka`,
      position: `PhD student, Researcher  `,
      description: `Vojtěch Sobotka completed his Bachelor's degree in Ecological and Evolutionary Biology at Masaryk University, followed by a Master's degree in Botany with a specialization in Plant Ecology. In his Bachelor's thesis, he studied the invasion of Mahonia aquifolium in the city of Brno. His Master's thesis focused on the succession of steppe vegetation on abandoned fields in South Moravia. Currently, his research focuses on the diversity of steppe grasslands, primarily in South Moravia, and on the possibilities for their ecological restoration. He is also interested in urban vegetation and plant invasions.`,
      email: `sobotka.v@sci.muni.cz`,
      phoneNumber: ``,
      is: `https://is.muni.cz/osoba/484029?lang=en`,
      orcid: `https://orcid.org/0000-0002-0668-3258`,
      img: sobotka,
    },
    {
      id: `szokala`,
      name: `Daniel Szokala`,
      position: `PhD student, Researcher`,
      description: `Daniel Szokala studied Landscape architecture and later Botany, in which he obtained a master’s degree. He is interested in the alpine vegetation of central Europe, the Balkans, Caucasus, and Anatolia. In his Ph.D. study, he focuses mainly on geographical patterns and functional diversity of alpine communities.`,
      email: `512772@muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/512772-daniel-szokala`,
      researchgate: `https://www.researchgate.net/profile/Daniel_Szokala`,
      orcid: `https://orcid.org/0000-0002-3593-1791`,
      img: szokala,
    },
    {
      id: `mones`,
      name: `Gonzalo Velasco Mones`,
      position: `PhD student, Researcher`,
      description: `Gonzalo is an environmental biologist bachelor with a master on Terrestrial Ecology by Universitat Autònoma de Barcelona from 2019. His main interests there were about ecological processes of Mediterranean vegetation caused by succession and climate change, with a progressive shift towards more theoretical aspects. His current work as a PhD student is on the functional ecology of Czech vegetation, both at a local and a country-wide scale, and its interrelationship with phylogenetic patterns to gain knowledge of the processes of community assembly along successional gradients. To be more confident on theoretical and statistical skills, he is also slow-pacedly obtaining a Mathematics bachelor by the (Spanish) National University of Remote Education (UNED).`,
      email: `gonzalo95nuncius@gmail.com`,
      phoneNumber: ``,
      is: `https://www.muni.cz/en/people/528870-gonzalo-velasco-mones`,
      researchgate: `https://www.researchgate.net/profile/Gonzalo-Velasco-Mones`,
      img: mones,
    },
  ],
};

export const peopleCz = {
  employees: [
    {
      id: `chytry`,
      name: `Milan Chytrý`,
      position: `Profesor, Vedoucí skupiny`,
      description: `Milan Chytrý absolvoval doktorské studium v oboru botanika na Masarykově univerzitě v roce 1995. Zabývá se diverzitou vegetace, klasifikací rostlinných společenstev a metodami klasifikace, makroekologií, rostlinnými invazemi a paleoekologií. Editoval Katalog biotopů České republiky (2001, 2010) a čtyřdílnou monografii Vegetace České republiky (2007–2013). V letech 2014–2018 řídil projekt PLADIAS, který syntetizoval informace o flóře a vegetaci České republiky a zpřístupnil je v online databázi. Zkoumal vegetaci v různých částech Evropy. V letech 2003–2015 řídil projekty terénního výzkumu ekosystémů v různých částech Sibiře, během nichž byly objeveny a popsány současné analogie zaniklých ekosystémů posledního glaciálu v Evropě. V současné době koordinuje projekt Centrum pro evropské vegetační syntézy na Masarykově univerzitě. Je tajemníkem pracovní skupiny European Vegetation Survey Mezinárodní společnosti pro výzkum vegetace (IAVS), kustodem Evropského vegetačního archivu (EVA) a vedoucím redaktorem časopisů Journal of Vegetation Science a Applied Vegetation Science. Na Masarykově univerzitě přednáší ekologii společenstev a makroekologii, vegetaci a biotopy České republiky, vegetaci a biotopy Evropy a několik terénních cvičení a seminářů.`,
      email: `chytry@sci.muni.cz`,
      phoneNumber: `549494595`,
      is: `https://www.muni.cz/lide/871-milan-chytry`,
      orcid: `https://orcid.org/0000-0002-8122-3075`,
      publons: `https://publons.com/researcher/1609810/milan-chytry/`,
      scholar: `https://scholar.google.com/citations?user=scnnn1UAAAAJ&hl=cs&oi=ao`,
      researchgate: `https://www.researchgate.net/profile/Milan_Chytry`,
      personal: `https://www.sci.muni.cz/botany/chytry/index.htm`,
      img: chytry,
    },
    {
      id: `lososova`,
      name: `Zdeňka Lososová`,
      position: `Docent`,
      description: `Zdeňka Lososová pracuje na Ústavu botaniky a zoologie od roku 2004. Garantuje bakalářské a navazující magisterské studium učitelství biologie pro střední školy. Podílí se na výuce botanických a geobotanických seminářů a terénního cvičení z geobotaniky. Ve výzkumu se zabývá diverzitou vegetace, soustředí se především (ale nejenom) na vegetaci antropogenních stanovišť. Jedním z jejích hlavních výzkumných témat je vliv prostředí velkých evropských měst na výskyt cévnatých rostlin. S tímto tématem souvisejí otázky invazní biologie. V posledních letech se soustředí na studium funkční a fylogenetické diverzity rostlinných společenstev. Pomocí těchto charakteristik rostlinných společenstev se snaží zjistit, do jaké míry utvářejí rostlinná společenstva podmínky prostředí a biotické interakce.`,
      email: `lososova@sci.muni.cz`,
      phoneNumber: `549498399`,
      is: `https://www.muni.cz/lide/5767-zdenka-lososova`,
      orcid: `https://orcid.org/0000-0001-9152-7462`,
      publons: `https://publons.com/researcher/1641861/zdenka-lososova/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=E5qC_J8AAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Zdeka_Lososova`,
      img: lososova,
    },
    {
      id: `rolecek`,
      name: `Jan Roleček`,
      position: `Docent`,
      description: `Jana Rolečka zajímá ekologie a diverzita vegetace, především pak lesostepních biotopů teplomilných doubrav a stepních luk. Kromě popisu této diverzity se snaží porozumět i jejím příčinám, což jej přivedlo ke studiu lesostepí ve vzdálených oblastech Eurasie a také ke zkoumání jejich historie na různých časových škálách. Jako absolventa oboru ochrana a tvorba životního prostředí na Univerzity Palackého v Olomouci jej pálí také otázky ochrany ohrožených druhů a biotopů a část pracovní aktivity věnuje i jim. Po dokončení doktorského studia botaniky na Masarykově univerzitě (2001–2007) zůstal věrný Ústavu botaniky a zoologie, současně pracuje také v Botanickém ústavu AV ČR. Učí předměty ekologie lesa, chráněná území České republiky, příroda ve čtvrtohorách (s M. Horsákem) a speciální botanicko-zoologické cvičení v terénu (s Biotýmem).`,
      email: `rolecek@mail.muni.cz`,
      phoneNumber: `549498489`,
      is: `https://www.muni.cz/lide/42706-jan-rolecek`,
      orcid: `https://orcid.org/0000-0002-0023-1111`,
      publons: `https://publons.com/researcher/2518519/jan-rolecek/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=E0X-9JAAAAAJ`,
      researchgate: `https://www.researchgate.net/scientific-contributions/78391540_Jan_Rolecek`,
      img: rolecek,
    },
    {
      id: `tesitel`,
      name: `Jakub Těšitel`,
      position: `Docent`,
      description: `Jakub Těšitel vystudoval botaniku na Přírodovědecké fakultě Jihočeské univerzity v Českých Budějovicích, kde poté několik let působil jako vědecký pracovník a odborný asistent. Během magisterského a doktorského studia se zabýval taxonomií, ekologií a fyziologií poloparazitických rostlin z čeledi Orobanchaceae. Na Ústavu botaniky a zoologie Masarykovy univerzity působí od roku 2017. Vyučuje kurs Introduction to biostatistics in English a podílí se na výuce seminářů a terénních cvičení. Jeho hlavní specializací je ekologie parazitických rostlin. Zabývá se ale i mnoha dalšími tématy spojenými s biodiverzitou rostlinných společenstev, zejména bezlesí, jako jsou funkční vlastností rostlin a jejich význam v ekologii nebo proměnlivost stepních společenstev v čase. Kromě základního výzkumu uplatňuje své zkušenosti i v aplikované ekologii, kde se zabývá především obnovou biodiverzity na antropogenních stanovištích a možnostmi potlačit invazní a expanzivní rostliny pomocí poloparazitických druhů.`,
      email: `tesitel@sci.muni.cz`,
      phoneNumber: `549496974`,
      is: `https://www.muni.cz/lide/116967-jakub-tesitel`,
      orcid: `https://orcid.org/0000-0003-3793-3704`,
      publons: `https://publons.com/researcher/2869771/jakub-tesitel/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=ipOViTQAAAAJ`,
      researchgate: `https://www.researchgate.net/scientific-contributions/46226749_Jakub_Tesitel`,
      img: tesitel,
    },
    {
      id: `tichy`,
      name: `Lubomír Tichý`,
      position: `Docent`,
      description: `Lubomír Tichý absolvoval doktorský studijní program v oboru botanika na Masarykově univerzitě v roce 1999 s tématem dizertační práce "Vliv stanovištních podmínek na diverzitu vegetace". Zabývá se metodami a teoretickými aspekty sběru vegetačních dat a klasifikací rostlinných společenstev. Od roku 1988 souběžně realizuje a řídí praktickou ochranou přírody v několika zvláště chráněných územích. Je autorem počítačových programů JUICE, GLAMA, Probabilistic Vegetation Key a dalších, které slouží pro sběr a zpracování terénních vegetačních dat. Podílí se na výuce v předmětech populační ekologie rostlin, management ohrožených ekosystémů, zpracování základních botanických dat, terénní cvičení z geobotaniky, terénní exkurze k environmentálním problémům a botanický seminář – vegetace střední Evropy. Garantuje magisterský studijní program ochrana přírody.`,
      email: `tichy@sci.muni.cz`,
      phoneNumber: `549497673`,
      is: `https://www.muni.cz/lide/6669-lubomir-tichy`,
      orcid: `https://orcid.org/0000-0001-8400-7741`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=EqXZ7esAAAAJ`,
      researchgate: `https://www.researchgate.net/scientific-contributions/14637372_Lubomir_Tichy`,
      img: tichy,
    },
    {
      id: `axmanova`,
      name: `Irena Axmanová`,
      position: `Odborný asistent`,
      description: `Irena Axmanová vystudovala obor systematická biologie a ekologie na Přírodovědecké fakultě Masarykovy univerzity. Na stejném pracovišti v roce 2012 obhájila i dizertační práci v oboru botanika na téma "Vliv produktivity a dalších faktorů prostředí na diverzitu bylinného patra lesů". Podílela se i na projektu hledajícím současné analogie přírody v pozdním pleistocénu s otázkou, jak vypadala krajina mamutů a dalších velkých býložravců na severu Sibiře a v Beringii v době ledové. V současné době spolupracuje na projektech využívajících rozsáhlou fytocenologickou databázi Evropský vegetační archiv (EVA) ke studiu vegetace v kontinentálním měřítku. Mezi její hlavní zájmy patří vegetační ekologie, zastoupení nepůvodních druhů ve vegetaci a funkční a fylogenetická diverzita rostlinných společenstev.`,
      email: `axmanova@sci.muni.cz`,
      phoneNumber: `549498395`,
      is: `https://www.muni.cz/lide/78388-irena-axmanova`,
      orcid: `https://orcid.org/0000-0001-9440-7976`,
      publons: `https://publons.com/researcher/3126272/irena-axmanova/`,
      researchgate: `https://www.researchgate.net/profile/Irena_Axmanova`,
      img: axmanova,
    },
    {
      id: `danihelka`,
      name: `Jiří Danihelka`,
      position: `Odborný asistent`,
      description: `Jiří Danihelka absolvoval doktorské studium v oboru botanika na Přírodovědecké fakultě Masarykovy univerzity v roce 2000 prací na téma "Achillea millefolium agg. v České republice". Od té doby pracuje na Ústavu botaniky a zoologie, kde se v roce 2004 stal kurátorem herbáře Masarykovy univerzity (BRNU). Od téhož roku působí také na Botanickém ústavu Akademie věd České republiky v Průhonicích. V současnosti se zabývá hlavně správou herbářové sbírky, taxonomickými a chorologickými botanickými databázemi, přípravou určovacích příruček a monografií (Květena České republiky a Flóra Slovenska), jakož i floristikou a taxonomií zavlečených druhů a některých obtížnějších rodů středoevropské flóry, mj. Achillea, Cerastium, Epilobium, Stipa a Viola. Vyučuje předměty základní metody terénní botaniky, vědecká práce v botanice a zoologii, zpracování základních botanických dat, determinační praktikum krytosemenných rostlin a terénní cvičení k systematické botanice.`,
      email: `danihel@sci.muni.cz`,
      phoneNumber: `549493473`,
      is: `https://www.muni.cz/lide/5926-jiri-danihelka`,
      orcid: `https://orcid.org/0000-0002-2640-7867`,
      publons: `https://publons.com/researcher/2523760/jiri-danihelka/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=10pWhfkAAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Jii_Danihelka`,
      img: danihelka,
    },
    {
      id: `divisek`,
      name: `Jan Divíšek`,
      position: `Odborný asistent`,
      description: `Jan Divíšek vystudoval učitelství biologie a geografie na Masarykově univerzitě. Následně pokračoval na téže instituci doktorským studiem v oboru fyzická geografie a v roce 2015 obhájil disertační práci, která se zabývala biogeografií a beta diverzitou společenstev různých taxonomických skupin České republiky. V současnosti pracuje jako odborný asistent Ústavu botaniky a zoologie a také Geografického ústavu Masarykovy univerzity. Aktuálně se věnuje výzkumu biodiverzity, invazní ekologii a prostorovému modelování. Mezi otázky spojené s jeho výzkumem patří např.: Jaký je vliv historických změn krajiny na současné regionální rozdíly v druhové bohatosti rostlin? Jaké vlastnosti ovlivňují úspěšnost nepůvodních druhů? nebo Jak se mění rozšíření druhů i celých společenstev v reakci na změny prostření? `,
      email: `divisekjan@mail.muni.cz`,
      phoneNumber: `549498494`,
      is: `https://www.muni.cz/lide/106310-jan-divisek`,
      orcid: `https://orcid.org/0000-0002-5127-5130`,
      publons: `https://publons.com/researcher/2524551/jan-divisek/`,
      researchgate: `https://www.researchgate.net/profile/Jan_Divisek`,
      img: divisek,
    },
    {
      id: `novak`,
      name: `Pavel Novák`,
      position: `Odborný asistent`,
      description: `Pavel Novák studoval obor botanika, směr ekologie rostlin na Přírodovědecké fakultě Masarykovy univerzity. V roce 2013 obhájil diplomovou práci zaměřenou na diverzitu lesní vegetace Krumlovského lesa a okolí (JZ Morava), území vegetačně velmi zajímavého a přitom do té doby takřka neprozkoumaného. V roce 2014 začal doktorské studium, ve kterém pokračuje dodnes. Dizertační práce (2014–2020) byla zaměřena na variabilitu a syntaxonomii dubohabřin (řád Carpinetalia) na evropské škále. Vedle vegetace střední Evropy se věnuje lesní vegetaci Kavkazu a Euxinie.`,
      email: `269109@mail.muni.cz`,
      phoneNumber: `549498485`,
      is: `https://www.muni.cz/lide/269109-pavel-novak`,
      researchgate: `https://www.researchgate.net/profile/Pavel_Novak21`,
      img: novak,
    },
    {
      id: `klinkovska`,
      name: `Klára Friesová (Klinkovská)`,
      position: `Výzkumník`,
      description: `Klára Friesová studovala na Přírodovědecké fakultě Masarykovy univerzity nejprve bakalářský studijní program Ekologická a evoluční biologie a poté magisterský studijní program Botanika se zaměřením na ekologii rostlin. V rámci bakalářské práce se zabývala vegetační charakteristikou geograficky významných prvků květeny v okolí Slavkova u Brna. Ve své diplomové práci se zaměřila na vysokobylinnou stepní vegetaci jižní Moravy. V rámci svého doktorského studia se věnovala změnám nelesní vegetace České republiky v čase. Snaží se přispět k poznání hlavních faktorů způsobujících změny v rostlinných společenstvech a tím také k efektivní ochraně přírody.`,
      email: `474368@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/474368-klara-klinkovska`,
      researchgate: `https://www.researchgate.net/profile/Klara_Klinkovska`,
      orcid: `https://orcid.org/0000-0002-1644-2140`,
      img: klinkovska,
    },
    {
      id: `hajek`,
      name: `Ondřej Hájek`,
      position: `Výzkumník`,
      description: `Ondřej Hájek vystudoval magisterský obor kartografie a geoinformatika na Přírodovědecké fakultě Masarykovy univerzity. Nyní pracuje pro většinu pracovních skupin Ústavu botaniky a zoologie jako odborník pro práci s GIS a zároveň se zde podílí na výuce předmětu geografické informační systémy v botanice a zoologii.`,
      email: `ohajek@sci.muni.cz`,
      phoneNumber: `549494033`,
      is: `https://www.muni.cz/lide/16845-ondrej-hajek`,
      researchgate: `https://www.researchgate.net/profile/Ondej_Hajek`,
      img: hajek,
    },
    {
      id: `hanusova`,
      name: `Valérie Hanušová`,
      position: `Výzkumník`,
      description: `Valérie Hanušová vystudovala magisterský obor Ochrana přírody se specializací na botaniku na Přírodovědecké fakultě Masarykovy univerzity. Ve své diplomové práci se zabývala praktickou ochranou přírody skrze obnovu biodiverzity lučních porostů pomocí přenosu zeleného sena po potlačení dominance invazních druhů poloparazitickými rostlinami. V současnosti spolupracuje na přeshraničním projektu Interreg PannFlora zaměřeném na obnovu travinobylinných porostů a produkci regionálního osiva z původních druhů panonské flóry pro využití při obnově krajiny a sídelní zeleně.`,
      email: `541000@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://is.muni.cz/osoba/541000?lang=cz`,
      img: hanusova,
    },
    {
      id: `holubova`,
      name: `Dana Holubová`,
      position: `Výzkumník`,
      description: `Dana Holubová studovala obor systematická biologie a ekologie na Přírodovědecké fakultě Masarykovy univerzity. Na stejném pracovišti v roce 2016 obhájila i dizertační práci v oboru botanika na téma Diverzita vegetace v krajinném měřítku. V roce 2011 vytvořila a doposud spravuje webovou aplikaci Botanická fotogalerie. V současné době je zaměstnaná jako výzkumnice na Ústavu botaniky a zoologie Masarykovy univerzity, kde se věnuje především tvorbě botanických fotografických databází a doplňování webové aplikace PLADIAS.`,
      email: `danmich@mail.muni.cz`,
      phoneNumber: `549496974`,
      is: `https://www.muni.cz/lide/113226-dana-holubova`,
      researchgate: `https://www.researchgate.net/scientific-contributions/2149640262_Dana_Holubova`,
      img: holubova,
    },
    {
      id: `chytra`,
      name: `Helena Chytrá`,
      position: `Výzkumník`,
      description: `Věnuji se ochranářskému managementu suchých trávníků (včetně inovativních způsobů - vypalování, úhorování) a jejich zakládání a údržbě na orné půdě. Dále se zabývám možnostmi podpory biodiverzity v zemědělské krajině, zejména ve vinohradech. Ve volném čase se věnuji komunitní péči o krajinu.`,
      email: `chytra@sci.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/103586-helena-chytra`,
      img: chytra,
    },
    {
      id: `chytrykr`,
      name: `Kryštof Chytrý`,
      position: `Výzkumník`,
      description: `Kryštof Chytrý se zajímá o biogeografii středoevropské flóry a vegetace. Vedle zájmu o biogeografické patrnosti a gradienty ho však nejvíce zajímá, co je zdánlivě narušuje. Tím se dostal k otázkám jako je přítomnost stepních ok v jinak lesnatých krajinách, kterým se věnoval během magisterského studia, existence mikroklimatických refugií ve vysokých horách, čemuž se nyní věnuje během svého doktorského studia na Vídeňské univerzitě, a sezónní a meziroční dynamika suchých trávníků.`,
      email: `krystof.chytry@gmail.com`,
      phoneNumber: `+420731877397`,
      is: `https://www.muni.cz/en/people/237932-krystof-chytry`,
      orcid: `https://orcid.org/0000-0003-4113-6564`,
      researchgate: `https://www.researchgate.net/profile/Krystof-Chytry`,
      publons: `https://publons.com/researcher/4044399/krystof-chytry/`,
      personal: `https://twitter.com/Kryshpean21`,
      img: chytrykr,
    },
    {
      id: `iemelianova`,
      name: `Svitlana Iemelianova`,
      position: `Výzkumník`,
      description: `Svitlana Iemelianova je z Ukrajiny. Svou PhD práci vypracovala v roce 2015 na M.G. Kholodny Institute of Botany of the National Academy of Science of Ukraine. Zabývá se klasifikací vegetace, rostlinnými invazemi v různých typech prostředí a ochranou přírody.`,
      email: `yemelianova.sv@gmail.com`,
      is: `https://www.muni.cz/en/people/242944-svitlana-iemelianova`,
      orcid: `https://orcid.org/0000-0001-5885-3186`,
      researchgate: `https://www.researchgate.net/profile/Svitlana-Iemelianova`,
      publons: `https://publons.com/researcher/3340751/svitlana-iemelianova/`,
      img: iemelianova,
    },
    {
      id: `kalusova`,
      name: `Veronika Kalusová`,
      position: `Výzkumník`,
      description: `Veronika Kalusová studovala bakalářský i magisterský stupeň v oboru systematická biologie a ekologie na Přírodovědecké fakultě Masarykovy univerzity (2003–2009). V obou závěrečných pracích se zabývala stanovištními preferencemi nepůvodních druhů rostlin v říčních nivách na jihovýchodě Moravy. Poté navázala doktorským studiem oboru botanika taktéž na PřF MU, které zakončila v roce 2015. Ve své disertaci srovnávala důležitost evropských biotopů jako zdrojů nepůvodních druhů invadujících v Severní Americe a ve zbytku světa. Od roku 2009 pracuje jako výzkumnice na Ústavu botaniky a zoologie PřF MU a dále zkoumá jednotlivé aspekty invaze nepůvodních rostlin v různých typech vegetace Evropy se zvláštním zaměřením na člověkem silně ovlivněná stanoviště, jako jsou lidská sídla.`,
      email: `kalveron@tiscali.cz`,
      phoneNumber: `549494992`,
      is: `https://www.muni.cz/lide/106856-veronika-kalusova`,
      orcid: `https://orcid.org/0000-0002-4270-321X`,
      researchgate: `https://www.researchgate.net/profile/Veronika_Kalusova`,
      img: kalusova,
    },
    {
      id: `knollova`,
      name: `Ilona Knollová`,
      position: `Výzkumník`,
      description: `Ilona Knollová studovala obor systematická biologie a ekologie na Přírodovědecké fakultě Masarykovy univerzity. Na stejném pracovišti v roce 2006 obhájila i dizertační práci v oboru botanika na téma "Lokální a velkoplošné datové soubory a jejich využití pro klasifikaci vegetace". V současné době je správcem České národní fytocenologické databáze a databáze European Vegetation Archive (EVA).`,
      email: `ikuzel@sci.muni.cz`,
      phoneNumber: `549498488`,
      is: `https://www.muni.cz/lide/10355-ilona-knollova`,
      orcid: `https://orcid.org/0000-0003-4074-789X`,
      researchgate: `https://www.researchgate.net/profile/Ilona_Knollova`,
      img: knollova,
    },
    {
      id: `knotkova`,
      name: `Kateřina Knotková`,
      position: `Výzkumník`,
      description: `Kateřina Knotková je absolvenkou zahradní a krajinářské architektury na Zahradnické fakultě Mendelovy univerzity v Brně. Svou práci vždy soustředila především na rostliny. V bakalářské práci se zaměřila na tvorbu botanické zahrady z druhů typických pro rostlinná společenstva Národního parku Podyjí. V diplomové práci se pak zaměřila na testování rostlin, které by bylo možné pěstovat ve městech z přímého výsevu a také na dnes velmi diskutované téma dešťových záhonů. Nyní pokračuje ve studiích na Ústavu botaniky a zoologie, kde v rámci doktorátu řeší použití poloparazitických rostlin v ochraně přírody, jejich vliv na biodiverzitu a ekosystémové služby. Ve své práci se snaží kombinovat vědomosti a přístupy aplikované zahradnické praxe a základního botanického výzkumu.`,
      email: `501016@mail.muni.cz`,
      phoneNumber: `549496974`,
      is: `https://www.muni.cz/lide/501016-katerina-knotkova`,
      orcid: `https://orcid.org/0000-0001-6668-8977`,
      researchgate: `https://www.researchgate.net/profile/Katerina-Knotkova-3`,
      img: knotkova,
    },
	   {
      id: `kolenyova`,
      name: `Monika Kolényová`,
      position: `Výzkumník`,
      description: `Monika Kolényová vystudovala bakalářský a magisterský studijní program ekologická a evoluční biologie na Přírodovědecké fakultě Masarykovy univerzity v Brně. Zabývala se sukcessí lignikolních hub na tlejícich kmenech v přirozených lesích a jejich mikrostanovištích nárocích. V tomto tématu pokračovala i na disertační práci. `,
      email: `424056@mail.muni.cz`,
      phoneNumber: `549498397`,
      is: `https://www.sci.muni.cz/o-nas/zamestnanci-fakulty/424056`,
      researchgate: `https://www.researchgate.net/profile/Monika_Kolenyova`,
      img: kolenyova,
    },
    {
      id: `kubesova`,
      name: `Svatava Kubešová`,
      position: `Výzkumník`,
      description: `Svatava Kubešová ukončila studium na Masarykově univerzitě rigorózním řízením s tématem "Materiály k bryoflóře Moravy". Na Ústavu botaniky a zoologie se podílí na výuce bryologie dvěma určovacími kurzy. Její hlavní náplní práce je správa sbírky mechorostů jako kurátorka v Moravském zemském muzeu.`,
      email: `skubesova@mzm.cz`,
      phoneNumber: `545217322`,
      is: `https://www.muni.cz/lide/18604-svatava-kubesova`,
      orcid: `https://orcid.org/0000-0002-7895-6710`,
      publons: `https://publons.com/researcher/2339456/svatava-kubesova/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=g1_cBe0AAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Svatava_Kubesova`,
      img: kubesova,
    },
    {
      id: `landucci`,
      name: `Flavia Landucci`,
      position: `Výzkumník`,
      description: `Flavia Landucci vystudovala přírodní vědy na Univerzitě v Perugii v Itálii. Během svého bakalářského a magisterského studia se zabývala rozšířením, ekologií a fytochemií nepůvodního druhu Senecio inaequidens v Itálii. V této době si oblíbila ekologii rostlin. Během doktorského studia začala rozvíjet svůj zájem o vodní a mokřadní vegetaci. Do Brna přišla poprvé během doktorského studia díky programu Erasmus v roce 2010. Na Masarykově univerzitě našla velmi pozitivní prostředí, které ji povzbudilo, aby pokračovala ve svém výzkumu po doktorátě. V roce 2011 získala doktorský titul s prací Klasifikace vodní a mokřadní vegetace ve střední Itálii. V roce 2013 uspěla v projektu SoMoPro (spolufinancovaný programem Marie Curie a Jihomoravským krajem) a od té doby pracuje ve skupině Výzkum vegetace na Ústavu botaniky a zoologie Masarykovy univerzity. Její výzkum je v současné době zaměřen především na klasifikaci vodní a mokřadní vegetace Evropy.`,
      email: `386683@mail.muni.cz`,
      phoneNumber: `549498479`,
      is: `https://www.muni.cz/lide/386683-flavia-landucci`,
      orcid: `https://orcid.org/0000-0002-6848-0384`,
      publons: `https://publons.com/researcher/1282963/flavia-landucci/`,
      scholar: `https://scholar.google.com/citations?hl=cs&user=UJn3DmQAAAAJ`,
      researchgate: `https://www.researchgate.net/profile/Flavia_Landucci`,
      img: landucci,
    },
    {
      id: `preislerova`,
      name: `Zdenka Preislerová`,
      position: `Výzkumník`,
      description: `Zdenka Preislerová studovala na Masarykově univerzitě obor systematická botanika a geobotanika. Ve své diplomové práci se věnovala studiu plevelové vegetace v Bílých Karpatech. V navazujícím doktorském studiu studovala na příkladu lesní i luční vegetace vliv velikosti plochy na analýzy a klasifikaci vegetace. Zajímavá krajina moravských Karpat a nezodpovězené otázky týkající se rozdílné druhové diverzity suchých stávníků na jižní Moravě ve srovnání s bělokarpatskými loukami se odrazily v předmětu jejího dalšího studia. V současné době se také podílí na zpracování databáze fytocenologických svazů evropské vegetace.`,
      email: `zpreislerova@gmail.com`,
      phoneNumber: `549498477`,
      is: `https://www.muni.cz/lide/10230-zdenka-preislerova`,
      researchgate: `https://www.researchgate.net/profile/Zdenka_Preislerova`,
      img: preislerova,
    },
    {
      id: `reznickova`,
      name: `Marcela Řezníčková`,
      position: `Výzkumník`,
      description: `Marcela Řezníčková vystudovala magisterský obor systematická biologie a ekologie na Přírodovědecké fakultě Masarykovy univerzity (1995–2000). Toto studium ukončila obhajobou diplomové práce na téma "Lesní vegetace Chřibů". Od roku 2002 pokračovala doktorským studiem na stejné univerzitě a v roce 2007 obhájila dizertační práci "Variabilita luk svazu Molinion v České a Slovenské republice". V současnosti je výzkumnicí na Ústavu botaniky a zoologie a zabývá se zejména správou databáze PLADIAS.`,
      email: `mar.reznickova@seznam.cz`,
      phoneNumber: `549498488`,
      is: `https://www.muni.cz/lide/19437-marcela-reznickova`,
      researchgate: `https://www.researchgate.net/profile/Marcela_Reznickova`,
      img: reznickova,
    },
    {
      id: `smerdova`,
      name: `Eva Šmerdová (Hettenbergerová)`,
      position: `Výzkumník (rodičovská dovolená)`,
      description: `Eva Šmerdová získala bakalářský titul na Ostravské univerzitě, kde se její práce zaměřovala na flóru a vegetaci hald. Magisterské studium botaniky ukončila v roce 2006 na Přírodovědecké fakultě Masarykovy univerzity diplomovou prací zabývající se vlivem kontaktních společenstev na druhové složení lučních pramenišť. Doktorskou práci na téma "Druhová bohatost a variabilita rostlin a měkkýšů na vlhkostním gradientu" obhájila v roce 2013. V současné době se zabývá výzkumem vlivu zasněžování na vegetaci, zpracováním historických vegetačních snímků a správou databáze rostlinných makrozbytků České a Slovenské republiky. Spolupracuje na projektu zkoumajícím refugia ohrožených slatiništních rostlin. Eva se podíli na prezentaci botaniky a zoologie veřejnosti, především pak studentům středních a základních škol. Také spolupracuje se na přípravě Biologické olympiády. Ráda cestuje s kolegy po rodné vlasti i do zahraničí a sbírá terénní data k dalšímu výzkumu vegetace.`,
      email: `smerdova@sci.muni.cz`,
      phoneNumber: `549498487`,
      is: `https://www.muni.cz/lide/75764-eva-smerdova`,
      orcid: `https://orcid.org/0000-0003-4589-6317`,
      researchgate: `https://www.researchgate.net/profile/Eva-Smerdova-2`,
      publons: `https://publons.com/researcher/4960709/eva-smerdova/`,
      img: smerdova,
    },
        {
      id: `tesitelova`,
      name: `Tamara Těšitelová`,
      position: `Výzkumník`,
      description: `Tamara Těšitelová vystudovala botaniku na Přírodovědecké fakultě Jihočeské univerzity, kde v roce 2014 obhájila disertační práci s názvem „Ekologické a evoluční důsledky závislosti orchidejí na mykorhizních houbách“. Pro studium orchideoidní mykorhizy využila pestrou škálu přístupů od terénních experimentů s vyséváním orchidejových semen, izolace a molekulární identifikace hub, včetně metabarkódování environmentální DNA, a fylogenetických analýz až po elektronovou mikroskopii či složení stabilních izotopů. Na Ústavu botaniky a zoologie MU působí od roku 2021 a věnuje se zde využití poloparazitických rostlin pro potlačení invazních rostlinných druhů a také využití databází pro studium ekologie mykoheterotrofních rostlin. Nadále pracuje i na Jihočeské univerzitě především na otázkách antropogenního ovlivnění společenstev orchideoidních hub v půdě a využití houbového inokula pro obnovu populací orchidejí v přírodě.`,
      email: `tamara.malinova@centrum.cz`,
      is: `https://www.muni.cz/en/people/246803-tamara-tesitelova`,
      orcid: `https://orcid.org/0000-0001-6901-6359`,
      img: tesitelova,
    },
    {
      id: `vecera`,
      name: `Martin Večeřa`,
      position: `Výzkumník`,
      description: `Martin Večeřa vystudoval geografii se zaměřením na ekologii krajiny a biogeografii na Přírodovědecké fakultě Masarykovy univerzity. Ve své diplomové práci se věnoval šíření lesních rostlin dřevinnými pásy (potenciálními biokoridory) v zemědělské krajině. Jeho disertační práce byla zaměřená na různé ekologické a biogeografické aspekty druhové diverzity lesů a trávníků v Evropě.`,
      email: `martinvec@seznam.cz`,
      phoneNumber: `549498494`,
      is: `https://www.muni.cz/lide/357693-martin-vecera`,
      orcid: `https://orcid.org/0000-0001-8507-791X`,
      researchgate: `https://www.researchgate.net/profile/Martin_Vecera`,
      img: vecera,
    },
    {
      id: `drevojan`,
      name: `Pavel Dřevojan`,
      position: `Technik`,
      description: `Pavel Dřevojan vystudoval obor botanika, směr ekologie rostlin na Přírodovědecké fakultě Masarykovy univerzity. Ve své bakalářské práci se věnoval xerotermní flóře a vegetaci zářezů železniční trati Veselí nad Moravou – Vrbovce a v rámci diplomové práce studoval diverzitu vegetace polních plevelů jihovýchodního Znojemska. Mezi jeho hlavní zájmy patří studium flóry a vegetace jižní Moravy. Zajišťuje sběr a zpracování botanických dat pro různé projekty pracovní skupiny Výzkum vegetace.`,
      email: `269768@mail.muni.cz`,
      phoneNumber: `549498486`,
      is: `https://www.muni.cz/lide/269768-pavel-drevojan`,
      orcid: `https://orcid.org/0000-0003-0802-3509`,
      publons: `https://publons.com/researcher/1805476/pavel-drevojan/`,
      researchgate: `https://www.researchgate.net/profile/Pavel_Devojan`,
      img: drevojan,
    },
    {
      id: `galuskova`,
      name: `Hana Hrdličková (Galušková)`,
      position: `Technik (rodičovská dovolená)`,
      description: `Hana Hrdličková vystudovala dvojobor Učitelství biologie a matematiky pro střední školy v programu ekologická a evoluční biologie na Přírodovědecké fakultě Masarykovy univerzity. Floristicky zaměřenou diplomovou práci obhájila v roce 2014. Nyní pracuje v herbáři Masarykovy univerzity.`,
      email: `357936@mail.muni.cz`,
      phoneNumber: `549494813`,
      is: `https://www.muni.cz/lide/357936-hana-galuskova`,
      img: galuskova,
    },
  ],
  phdStudents: [
    {
      id: `erkelenz`,
      name: `Joshua André Erkelenz`,
      position: `Doktorand`,
      description: `Joshua Erkelenz studoval lesnictví a ekologii lesa na Georg-August University v německém Göttingenu. Před a během svého magisterského programu v tropickém a mezinárodním lesnictví se podílel na několika výzkumných projektech v zahraničí a absolvoval diplomovou prací o vzorech funkční rozmanitosti na ostrově Tenerife. Na Ústavu botaniky a zoologie MU zkoumá v rámci svého doktorského studia funkční a fylogenetickou diverzitu v lesních společenstvech podél výškových gradientů v evropských pohořích. Část svého času věnuje pěstování tropických a subtropických plodin.`,
      email: `erkelenz@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/528856-joshua-andre-erkelenz`,
      orcid: `https://orcid.org/0009-0005-7339-6741`,
      researchgate: `https://www.researchgate.net/profile/Joshua-Erkelenz`,
      img: erkelenz,
    },
    {
      id: `fahs`,
      name: `Nina Fahs`,
      position: `Doktorand, výzkumník`,
      description: `Nina Fahs vystudovala mezinárodní technickou a aplikovanou biologii na City University of Applied Sciences v Brémách v Německu. Po dokončení magisterského projektu, ve kterém Nina pracovala na popisu a klasifikaci mesických aluviálních trávníků v severním Německu, nastoupila v roce 2020 jako doktorandka na PřF MU. Ve svém studium se nyní zabývá interakcí mezi hemiparazitickými a bobovitými rostlinami se zaměřením na travní společenstva. Nina se široce zajímá o geobotaniku, využití rozsáhlých databází vegetačních dat pro základní i aplikovaný výzkum a ochranu přírody, zejména ochranu a obnovu polopřirozených druhově bohatých travních porostů.`,
      email: `nina@sci.muni.cz`,
      phoneNumber: `549498395`,
      is: `https://www.muni.cz/lide/528656-nina-fahs`,
      researchgate: `https://www.researchgate.net/profile/Nina-Fahs`,
      orcid: `https://orcid.org/0000-0003-4078-7672`,
      img: fahs,
    },
    {
      id: `franc`,
      name: `Martin Franc`,
      position: `Doktorand, výzkumník`,
      description: `Martin Franc vystudoval obor Ekologie a ochrana životního prostředí na Univerzitě Palackého v Olomouci, kde se během svého studia věnoval ohrožené flóře luk střední části Bílých Karpat a následně ekologii polopřirozených lučních společenstev v Lotyšsku, zejména jejich vazbě na půdní prostředí. V rámci doktorského studia se zabývá ekologií specializovaných funkčních skupin rostlin jako jsou paraziti, mykoheterotrofní rostliny, masožravé rostliny a fixátoři dusíku, zejména jejich vazbě na podmínky půdního prostředí.`,
      email: `437048@mail.muni.cz`,
      is: `https://www.muni.cz/en/people/437048-martin-franc`,
      researchgate: `https://www.researchgate.net/profile/Martin_Franc2`,
      img: franc,
    },
    {
      id: `hubatka`,
      name: `Petr Hubatka`,
      position: `Doktorand, výzkumník  `,
      description: `Petr Hubatka vystudoval v roce 2023 magisterský obor Botanika na Přírodovědecké fakultě Masarykovy univerzity. Ve své diplomové práci se zabýval flórou a vegetací polních mokřadů na jižní Moravě. Nyní se v doktorském studiu zabývá diverzitou a ekologií opadavých doubrav v jihovýchodní Evropě. Zajímá ho flóra a vegetace Evropy a faktory, které ovlivňují jejich podobu.`,
      email: `460527@mail.muni.cz`,
      is: `https://www.muni.cz/en/people/460527-petr-hubatka`,
      researchgate: `https://www.researchgate.net/profile/Petr-Hubatka`,
      orcid: `https://orcid.org/0000-0001-8178-5230`,
      img: hubatka,
    },
    {
      id: `jaskova`,
      name: `Anni Kanerva Jašková`,
      position: `Doktorand, výzkumník (rodičovská dovolená)`,
      description: `Anni Jašková pochází z Finska, kde studovala ekologii na Univerzitě v Turku. Je doktorandkou se specializací na boreální vegetaci. Hlavním cílem její práce je vytvoření jednotné klasifikace boreálních lesů v evropském měřítku, ale zajímá se také o teoretickou ekologii, zejména o rostlinné strategie a vztahy mezi rostlinami a býložravci. Před studiem boreálních společenstev zkoumala společenstva arktická, především vztahy mezi lumíky a lišejníky v tundře.`,
      email: `annipyy@mail.muni.cz`,
      phoneNumber: `549498395`,
      is: `https://www.muni.cz/lide/452344-anni-kanerva-pyykoenen`,
      researchgate: `https://www.researchgate.net/profile/Anni_Pyykoenen`,
      orcid: `https://orcid.org/0000-0002-3510-1093`,
      img: jaskova,
    },
		{
      id: `karnail`,
      name: `Anisha Ajay Karnail`,
      position: `Doktorand, výzkumník`,
      description: `Anisha Karnail vystudovala biologii na Indickém institutu pro vědecké vzdělávání a výzkum v Pune v Indii. V roce 2022 dokončila svůj magisterský projekt, v němž analyzovala vzorce růstu stromů v závislosti na gradientech prostředí v různých typech lesů jižní Indie. Po krátkém působení v oblasti vědecké komunikace a výzkumu městské ekologie, se od roku 2026 ve svém doktorském studiu zabývá ekofyziologickými interakcemi parazitického jmelí a jeho hostitelských druhů stromů ve střední Evropě. Její široké výzkumné zájmy se týkají ochrany biodiverzity, obnovy a udržitelnosti měst.`,
      email: `590504@muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/590504-anisha-ajay-karnail`,
      researchgate: ``,
	  orcid: ``, 
      img: karnail,
    },	
		{
      id: `kellermannova`,
      name: `Julia Kellermannová`,
      position: `Doktorand, výzkumník`,
      description: `Julia Kellermannová vystudovala bakalářský obor Biologie a Ekologie, a následně magisterský obor Botanika na Univerzitě Palackého v Olomouci. Ve své bakalářské i diplomové práci se věnovala funkční variabilitě lesních druhů bylin na lokálním gradientu prostředí. V rámci svého doktorského studia se bude zabývat vegetačními, floristickými a funkčními změnami Evropských mokřadů. Cílem této práce bude kromě zjištění trendů a faktorů změn, také tvorba Evropské databáze opakovaných snímků mokřadní vegetace a optimalizace managementových zásahů a revitalizací těchto typů stanovišť.`,
      email: `499970@mail.muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/499970`,
      researchgate: ``,
	  orcid: ``, 
      img: kellermannova,
    },
    {
      id: `klimova`,
      name: `Barbora Klímová`,
      position: `Doktorand, výzkumník`,
      description: `Barbora Klímová vystudovala fyzickou geografii na Přírodovědecké fakultě Masarykovy univerzity, kde se specializovala na krajinnou ekologii a biogeografii. Ve své diplomové práci se zabývala vlivem map půdního pH na přesnost modelů rozšíření rostlin. V současnosti pokračuje ve studiu na Ústavu botaniky a zoologie, kde se v rámci doktorského studia zaměřuje na faktory, které ovlivňují přesnost geografických modelů rozšíření a druhové diverzity rostlin. `,
      email: `470403@muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/470403-barbora-klimova`,
      researchgate: `https://www.researchgate.net/profile/Barbora_Klimova`,
      orcid: ``,
      img: klimova,
    },
 
    {
      id: `pustkova`,
      name: `Štěpánka Pustková`,
      position: `Doktorand, výzkumník`,
      description: `Štěpánka Pustková vystudovala na Masarykově uiverzitě bakalářský program Ekologická a evoluční biologie a magisterský program Botanika se zaměřením na vegetační ekologii. V bakalářské práci se zabývala dlouhodobými změnami lesní vegetace v Beskydském podhůří. Ve své diplomové práci zkoumala flóru a vegetaci revitalizovaných mokřadů na jižní Moravě. V dizertaci se opět vrátila k tématu změn lesní vegetace, tentokrát však v jihovýchodní Evropě.`,
      email: `499933@muni.cz`,
      is: `https://www.sci.muni.cz/o-nas/zamestnanci-fakulty/499933-stepanka-pustkova`,
      orcid: `https://orcid.org/0000-0002-9384-4872`,
      img: pustkova,
    },
	{
      id: `sobotka`,
      name: `Vojtěch Sobotka`,
      position: `Doktorand, výzkumník`,
      description: `Vojtěch Sobotka vystudoval bakalářský program Ekologická a evoluční biologie na Masarykově univerzitě, na který navázal magisterským studiem oboru Botanika se zaměřením na ekologii rostlin. Ve své bakalářské práci se zabýval invazí mahónie cesmínolisté na území Brna, v diplomové práci pak studoval sukcesi stepní vegetace na opuštěných polích jižní Moravy. V současnosti se věnuje výzkumu diverzity stepních trávníků převážně na jižní Moravě a možnostem jejich ekologické obnovy. Dlouhodobě se také zajímá o vegetaci měst a problematiku rostlinných invazí.`,
      email: `sobotka.v@sci.muni.cz`,
      phoneNumber: ``,
      is: `https://is.muni.cz/osoba/484029?lang=cs`,
      orcid: `https://orcid.org/0000-0002-0668-3258`,
      img: sobotka,
    },
    {
      id: `szokala`,
      name: `Daniel Szokala`,
      position: `Doktorand, výzkumník`,
      description: `Daniel Szokala studoval obor Zahradní a krajinářská architektura a později obor Botanika, ve kterém získal magisterský titul. Věnuje se studiu alpínské vegetace, a to jak střední Evropy, tak Balkánu, Kavkazu a Anatolie. V rámci jeho současného studia vegetační ekologie jej zajímají zejména geografické patterny, funkční vlastnosti rostlin a diverzita společenstev.`,
      email: `512772@muni.cz`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/512772-daniel-szokala`,
      researchgate: `https://www.researchgate.net/profile/Daniel_Szokala`,
      orcid: `https://orcid.org/0000-0002-3593-1791`,
      img: szokala,
    },
    {
      id: `mones`,
      name: `Gonzalo Velasco Mones`,
      position: `Doktorand, výzkumník`,
      description: `Gonzalo absolvoval v roce 2019 magisterský stupeň terestrické ekologie na Universitat Autònoma de Barcelona. Jeho hlavním zájmem byly ekologické procesy mediteránní vegetace způsobené sukcesí a změnou klimatu. Aby měl větší jistotu v teoretických a statistických dovednostech, získal také bakalářský titul z matematiky na (Spanish) National University of Remote Education (UNED). Jeho současná doktorská práce se zabývá funkční ekologií vegetace ČR v lokálním i celorepublikovém měřítku a jejím vzájemným vztahem k fylogenetickým vzorcům. Cílem je získat znalosti o procesech ve společenstvech podél sukcesních gradientů. `,
      email: `gonzalo95nuncius@gmail.com`,
      phoneNumber: ``,
      is: `https://www.muni.cz/lide/528870-gonzalo-velasco-mones`,
      researchgate: `https://www.researchgate.net/profile/Gonzalo-Velasco-Mones`,
      img: mones,
    },
  ],
};

export const formerPeople = [
  {
    name: `Mirjana Ćuk (2023–2024)`,
    email: `mirjana.cuk.rs@gmail.com`,
  },
  {
    name: `Marta Gaia Sperandii (2022–2024)`,
    email: `martagaia.sperandii@uniroma3.it`,
  },
  {
    name: `Markéta Táborská (2012–2024)`,
    email: `taborska.mar@gmail.com`,
  },
  {
    name: `Dariia Borovyk (Shyriaieva) (2022–2024)`,
    email: `dariiaborovyk@gmail.com`,
  },
  {
    name: `Adam Knotek (2022–2024)`,
    email: `fruticulus@gmail.com`,
  },
  {
    name: `Agathe Toumoulin (2022–2023)`,
    email: `agathe.toumoulin@gmail.com`,
  },
  {
    name: `Ricarda Pätsch (2021–2023)`,
    email: `ricarda.paetsch@gmail.com`,
  },
  {
    name: `Petra Štěpánková (2014–2023)`,
    email: `petra.stepankova@lipka.cz`,
  },
  {
    name: `Natálie Čeplová (2009–2023)`,
    email: `ceplova@ped.muni.cz`,
  },
  {
    name: `Gianluigi Ottaviani (2022–2023)`,
    email: `gianluigi.ottaviani@gmail.com`,
  },
  { name: `Gabriele Midolo (2021–2023)`, email: `gabriele.midolo@gmail.com` },
  {
    name: `Dominik Zukal (2015–2022)`,
    email: `375623@mail.muni.cz`,
  },
  {
    name: `Josep Padullés Cubino (2019–2022)`,
    email: `padullesj@gmail.com `,
  },
  {
    name: `Corrado Marcenò (2019–2022)`,
    email: `marcenocorrado@libero.it`,
  },
  {
    name: `Felícia Miranda Fischer (2019–2021)`,
    email: `feliciafischerster@gmail.com`,
  },
  {
    name: `Lars Götzenberger (2018–2020)`,
    email: `lars.goetzenberger@gmail.com`,
  },
  {
    name: `Markéta Chudomelová (2013–2020)`,
    email: `marketa.chudomelova@ibot.cas.cz`,
  },
  {
    name: `Veronika Kalníková (2011–2020)`,
    email: `V.Kalnikova@seznam.cz`,
  },
  {
    name: `Šárka Špániková (2019–2020)`,
    email: `408322@mail.muni.cz`,
  },
  {
    name: `Anna Kuzemko (2019–2020)`,
    email: `anyameadow.ak@gmail.com`,
  },
  {
    name: `Denys Vynokurov (2019–2020)`,
    email: `denys.vynokurov@gmail.com`,
  },
  {
    name: `Gianmaria Bonari (2017–2019)`,
    email: `gianmaria.bonari@gmail.com`,
  },
  {
    name: `Salza Palpurina (2010–2017)`,
    email: `salza.palpurina@gmail.com`,
  },
  {
    name: `Viktoria Wagner (2013–2016)`,
    email: `viktoria.wagner@ualberta.ca`,
  },
  {
    name: `Borja Jiménez-Alfaro (2013–2016)`,
    email: `jimenezalfaro.borja@gmail.com`,
  },
  {
    name: `David Zelený (2005–2015)`,
    email: `zeleny.david@gmail.com`,
  },
  {
    name: `Ching-Feng Li (2006–2015)`,
  },
  {
    name: `Marie Vymazalová (2007–2014)`,
    email: `meri@seznam.cz`,
  },
  {
    name: `Kristína Merunková (2006–2013)`,
    email: `KristinaMerunkova@seznam.cz`,
  },
  {
    name: `Barbora Pelánková (2004–2009)`,
    email: `bpelankova@gmail.com`,
  },
  {
    name: `Deana Láníková (2004–2009)`,
    email: `deanas@seznam.cz`,
  },
];

export const visitingScientistsCz = [
  {
    name: `Francesco Candini (Itálie, 2025)`,
  },
  {
    name: `Simone Eusebio Bergò (Itálie, 2025)`,
  },
  {
    name: `Irati Sanz-Zubizarreta (Španělsko, 2025)`,
  },
  {
    name: `Behlül Güler (Turecko, 2024)`,
  },
  {
    name: `Simona Sarmati (Itálie, 2024)`,
  },
  {
    name: `Federica Bonini (Itálie, 2023)`,
  },
  {
    name: `Hsun-Hung Chu (Taiwan, 2023)`,
  },
  {
    name: `Safiya Praleskouskaya (Itálie, 2022)`,
  },
  {
    name: `Dario Ciaramella (Itálie, 2022)`,
  },
  {
    name: `Filip Küzmič (Slovinsko, 2022)`,
  },
  {
    name: `Dariia Shyriaieva (Ukrajina, 2021)`,
  },
  {
    name: `Tatyana Vakhlamova (Kazachstán, 2021)`,
  },
  {
    name: `Marc Riera (Španělsko, 2021)`,
  },
  {
    name: `Tiina Kolari (Finsko, 2019)`,
  },
  {
    name: `Teemu Tahvanainen (Finsko, 2019)`,
  },
  {
    name: `Silvia Cannucci (Itálie, 2019)`,
  },
  {
    name: `Charlotte Ndiribe (Nigérie, 2018–2019)`,
  },
  {
    name: `Hamid Gholizadeh (Írán, 2018)`,
  },
  {
    name: `Filip Küzmič (Slovinsko, 2018)`,
  },
  {
    name: `Ekaterina Petrunenko (Rusko, 2017–2018)`,
  },
  {
    name: `Nicola Alessi (Itálie, 2017)`,
  },
  {
    name: `Emanuele Fanfarillo (Itálie, 2017)`,
  },
  {
    name: `Martina Vanini (Itálie, 2017)`,
  },
  {
    name: `Katarína Mikulová (Slovensko, 2016–2017)`,
  },
  {
    name: `Elisa Belmonte (Itálie, 2016)`,
  },
  {
    name: `Elena Brianskaia (Německo/Rusko, 2016)`,
  },
  {
    name: `Corrado Marcenò (Itálie, 2016)`,
  },
  {
    name: `Gianmaria Bonari (Itálie, 2015)`,
  },
  {
    name: `Marta Czarniecka-Wiera (Polsko, 2015)`,
  },
  {
    name: `Cloé Levointurier-Vajda (Francie, 2015)`,
  },
  {
    name: `José Valentín Roces Díaz (Španělsko, 2015)`,
  },
  {
    name: `Yi-Shin Chian (Taiwan, 2014–2015)`,
  },
  {
    name: `Corrado Marcenò (Itálie, 2014)`,
  },
  {
    name: `Miquel De Cáceres (Španělsko, 2013)`,
  },
  {
    name: `María Pilar Rodríguez-Rojo (Španělsko, 2013)`,
  },
  {
    name: `Nicola Alessi (Itálie, 2012)`,
  },
  {
    name: `Gianmaria Bonari (Itálie, 2012)`,
  },
  {
    name: `Adrian Indreica (Rumunsko, 2012)`,
  },
  {
    name: `Elia Angelini (Itálie, 2011)`,
  },
  {
    name: `Donald A. (Skip) Walker (USA, 2011)`,
  },
  {
    name: `Flavia Landucci (Itálie, 2010–2011)`,
  },
  {
    name: `Cheng-Tao Lin (Taiwan, 2010)`,
  },
  {
    name: `Daniela Dúbravková (Slovensko, 2008)`,
  },
  {
    name: `Attila Lengyel (Maďarsko, 2008)`,
  },
  {
    name: `Anna Szabó (Rumunsko, 2006)`,
  },
  {
    name: `Eszter Illyés (Maďarsko, 2005)`,
  },
  {
    name: `Rossen Tzonev (Bulharsko, 2004)`,
  },
  {
    name: `Zoltán Botta-Dukát (Maďarsko, 2003)`,
  },
];

export const visitingScientistsEn = [
  {
    name: `Francesco Candini (Italy, 2025)`,
  },
  {
    name: `Simone Eusebio Bergò (Italy, 2025)`,
  },
  {
    name: `Irati Sanz-Zubizarreta (Spain, 2025)`,
  },
  {
    name: `Behlül Güler (Turkey, 2024)`,
  },
  {
    name: `Simona Sarmati (Italy, 2024)`,
  },
  {
    name: `Federica Bonini (Italy, 2023)`,
  },
  {
    name: `Hsun-Hung Chu (Taiwan, 2023)`,
  },
  {
    name: `Safiya Praleskouskaya (Italy, 2022)`,
  },
  {
    name: `Dario Ciaramella (Italy, 2022)`,
  },
  {
    name: `Filip Küzmič (Slovenia, 2022)`,
  },
  {
    name: `Dariia Shyriaieva (Ukraine, 2021)`,
  },
  {
    name: `Tatyana Vakhlamova (Kazakhstan, 2021)`,
  },
  {
    name: `Marc Riera (Spain, 2021)`,
  },
  {
    name: `Tiina Kolari (Finland, 2019)`,
  },
  {
    name: `Teemu Tahvanainen (Finland, 2019)`,
  },
  {
    name: `Silvia Cannucci (Italy, 2019)`,
  },
  {
    name: `Charlotte Ndiribe (Nigeria, 2018–2019)`,
  },
  {
    name: `Hamid Gholizadeh (Iran, 2018)`,
  },
  {
    name: `Filip Küzmič (Slovenia, 2018)`,
  },
  {
    name: `Ekaterina Petrunenko (Russia, 2017–2018)`,
  },
  {
    name: `Nicola Alessi (Italy, 2017)`,
  },
  {
    name: `Emanuele Fanfarillo (Italy, 2017)`,
  },
  {
    name: `Martina Vanini (Italy, 2017)`,
  },
  {
    name: `Katarína Mikulová (Slovakia, 2016–2017)`,
  },
  {
    name: `Elisa Belmonte (Italy, 2016)`,
  },
  {
    name: `Elena Brianskaia (Germany/Russia, 2016)`,
  },
  {
    name: `Corrado Marcenò (Italy, 2016)`,
  },
  {
    name: `Gianmaria Bonari (Italy, 2015)`,
  },
  {
    name: `Marta Czarniecka-Wiera (Poland, 2015)`,
  },
  {
    name: `Cloé Levointurier-Vajda (France, 2015)`,
  },
  {
    name: `José Valentín Roces Díaz (Spain, 2015)`,
  },
  {
    name: `Yi-Shin Chian (Taiwan, 2014–2015)`,
  },
  {
    name: `Corrado Marcenò (Italy, 2014)`,
  },
  {
    name: `Miquel De Cáceres (Spain, 2013)`,
  },
  {
    name: `María Pilar Rodríguez-Rojo (Spain, 2013)`,
  },
  {
    name: `Nicola Alessi (Italy, 2012)`,
  },
  {
    name: `Gianmaria Bonari (Italy, 2012)`,
  },
  {
    name: `Adrian Indreica (Romania, 2012)`,
  },
  {
    name: `Elia Angelini (Italy, 2011)`,
  },
  {
    name: `Donald A. (Skip) Walker (USA, 2011)`,
  },
  {
    name: `Flavia Landucci (Italy, 2010–2011)`,
  },
  {
    name: `Cheng-Tao Lin (Taiwan, 2010)`,
  },
  {
    name: `Daniela Dúbravková (Slovakia, 2008)`,
  },
  {
    name: `Attila Lengyel (Hungary, 2008)`,
  },
  {
    name: `Anna Szabó (Romania, 2006)`,
  },
  {
    name: `Eszter Illyés (Hungary, 2005)`,
  },
  {
    name: `Rossen Tzonev (Bulgaria, 2004)`,
  },
  {
    name: `Zoltán Botta-Dukát (Hungary, 2003)`,
  },
];
